<template>
  <div class="page-signed">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">澳門門店</div>
      <div class="breadcrumb-item">已簽收</div>
    </div>

    <div class="card-block">
      <Form inline class="pg-form-inline">
        <!-- <FormItem>
            <Select size="small" placeholder="公司列表" v-model="form.order_parent" clearable>
                <Option :value="item.id" v-for="(item, index) in samcityType"
                        :key="item.id">
                        {{item.name}}
                </Option>
            </Select>
        </FormItem> -->
        <FormItem>
          <Select size="small" placeholder="提貨櫃點" v-model="form.arrive">
            <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
                    :key="item.ReceivingID">({{ item.cainiao_match }}) {{ item.ReceivingName }}
            </Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select size="small" placeholder="付款狀況" v-model="form.pay_type" ref="resetSelect" clearable>
            <Option value="0">未在APP內付款</Option>
            <Option value="1">已在APP內付款</Option>
          </Select>
        </FormItem>
        <FormItem>
          <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false" placeholder="澳門門店-簽收開始日期"
                      value-format="yyyy-MM-dd hh:mm:ss" style="width: 100%;" :editable="false"
                      v-model="form.start_time"></DatePicker>
        </FormItem>
        <FormItem>-</FormItem>
        <FormItem>
          <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false" placeholder="澳門門店-簽收結束日期"
                      value-format="yyyy-MM-dd hh:mm:ss" style="width: 100%;" :editable="false"
                      v-model="form.end_time"></DatePicker>
        </FormItem>
      </Form>

      <Form inline class="pg-form-inline form-input-wrap">
        <FormItem>
          <label class="input-label">模糊搜索</label>
          <Input size="small" clearable v-model="form.username" placeholder="(客戶電話/客戶名稱)"
                 @keyup.enter.native="handleSearch()" clearable></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">快遞單號</label>
          <Input size="small" clearable v-model="form.odd_numbers" @keyup.enter.native="handleSearch()"></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">客戶電話</label>
          <Input size="small" clearable v-model="form.phone" @keyup.enter.native="handleSearch()"></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">袋號</label>
          <Input size="small" clearable v-model="form.sack_number" @keyup.enter.native="handleSearch()"></Input>
        </FormItem>
        <FormItem>
          <div class="pg-btn-wrap">
            <div class="pg-btn style1" @click="handleSearch">搜索</div>
	          <!--<div class="pg-btn style2" @click="handleExport">導出excel</div>-->
	          <!--<export-excel class="pg-btn style2" ref="exportCsv" :data="csvData" type="csv" :fields="json_fields"
													:fetch="handleExport_zh" :name="csvFilename">導出excel-zh
						</export-excel>-->
            <div
	            class="pg-btn style2" @click="handleExport_zh">
              導出excel-zh
            </div>
          </div>
        </FormItem>
      </Form>
    </div>

    <div class="card-block pd-bt">
      <!-- <Spin fix class="pg-sub-loading" v-if="isSubmiting">
          <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
          <div class="loading-text">Loading</div>
      </Spin> -->
      <Table ref="table"
             size="small"
             border
             :loading="isSubmiting"
             no-data-text="暫無數據"
             :columns="table.column"
             :data="table.data"
             @on-selection-change="handleSelectionChange">
        <template slot-scope="{ row, index }" slot="odd_numbers">
          <div class="avatar-box">
            <a class="pg-btn" @click="handleViewOrder(index)">{{ row.odd_numbers }}</a>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <div class="pg-btn-wrap">
            <div class="pg-btn style1" @click="handleViewRemark(index)">備註</div>
            <div class="pg-btn style2" @click="handleViewOrder(index)">物流</div>
          </div>
        </template>
      </Table>

      <div class="pg-pagger">
        <Row>
          <Col span="12" class="pagger-left">
            <div class="pagger-total">總共 {{ totalCount }} 條記錄</div>
            <span class="total-price">應收款金額：{{ sums }}</span>
          </Col>
          <Col span="12" class="pagger-right">
            <!-- v-if="totalCount > curPageSize" -->
            <div>
              <div class="pagger-sizer">
                <span>每頁</span>
                <Select v-model="curPageSize" size="small" placeholder="數量"
                        @on-change="handlePageSizeChange">
                  <Option :value="10">10</Option>
                  <Option :value="20">20</Option>
                  <Option :value="30">30</Option>
                  <Option :value="40">40</Option>
                  <Option :value="50">50</Option>
                </Select>
              </div>

              <div class="pagger-elevator">
                <span>跳轉</span>
                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                       @on-enter="handlePageEnter"/>
              </div>

              <Page size="small"
                    :current="pageIndex"
                    :page-size="curPageSize"
                    :total="totalCount"
                    @on-change="handlePageChange">
              </Page>
            </div>
          </Col>
        </Row>
      </div>
    </div>

    <Modal v-model="isShowModalSign_goods"
           title="查詢快件"
           width="1200"
           :footer-hide="true"
           @on-cancel="handleModalSignClose_goods">
      <div class="modal-cont">
        <Spin fix class="pg-sub-loading" v-if="isSubmitingLog">
          <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
          <div class="loading-text">Loading</div>
        </Spin>

        <div style="font-weight:bold">快遞信息</div>
        <br>
        <Table no-data-text="" :columns="table1.column" :data="table1.data"></Table>
        <Table no-data-text="" :columns="table1.column1" :data="table1.data1"></Table>
        <Table no-data-text="" :columns="table1.column2" :data="table1.data2"></Table>
        <Table no-data-text="" :columns="table1.column3" :data="table1.data3">
          <template slot-scope="{row,index}" slot="status">
            <span v-if="row.status == 0">珠海倉庫-待出庫</span>
            <span v-else-if="row.status == 1">珠海倉庫-已出庫</span>
            <span v-else-if="row.status == 2">澳門倉庫-配送中</span>
            <span v-else-if="row.status == 3">澳門門店/智能櫃-未簽收</span>
            <span v-else-if="row.status == 4">澳門門店/智能櫃-已簽收</span>
          </template>
        </Table>
        <Table no-data-text="" :columns="table1.column4" :data="table1.data4"></Table>
        <Table no-data-text="" :columns="table1.column5" :data="table1.data5"></Table>
        <br><br>
        <div style="font-weight:bold">物流信息</div>
        <br>
        <div class="step-wrap" v-if="detail && detail.length">
          <div class="step-item clearfix" v-for="(item, index) in detail" :key="item.id">
            <div class="left">
              <div class="l-date">
                <span>{{ item.date }}</span>
                <span>{{ item.week }}</span>
              </div>
              <div class="l-time">{{ item.time }}</div>
            </div>
            <div class="right">
              <div class="r-address">{{ item.describe }} , 操作人：{{ item.userinfos }}</div>
            </div>
          </div>
        </div>

        <div class="data-null" v-else>
          <div>暫無數據</div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Store from '../../../assets/js/store.js'
import xlsx from "json-as-xlsx"
import dayjs from "dayjs"

let isthis;
export default {
	data() {
		return {
			pageIndex: 1,
			curPageSize: 10,
			totalCount: 1,
			pageInput: '',
			pickAddress: [],

			detail: [],
			form: {
				arrive: Store.fetch().store_id, //提貨櫃點ID
				start_time: '',
				end_time: '',
				odd_numbers: '',
				phone: '',
				sack_number: '',
				username: '',
				pay_type: '',
				// order_parent: ''
			},
			samcityType: [],
			sums: 0,
			isSubmiting: false,
			isLoadExcel: false,
			isShowModalSign_goods: false,
			isSubmitingLog: false,
			table: {
				column: [
					{
						type: 'selection',
						width: 60,
						align: 'center',
					},
					{
						title: '操作',
						slot: 'action',
						align: 'center',
						minWidth: 150
					},
					{
						title: '新/舊',
						key: 'order_type',
						align: 'center',
						minWidth: 70
					},
					{
						title: '一/二次支付',
						key: 'order_online',
						align: 'center',
						minWidth: 80
					},
					// {
					//     title: '付款狀況',
					//     key: 'pay_type',
					//     align: 'center',
					//     minWidth: 130,
					//     sortable: true
					// },
					{
						title: '客戶名稱【積分】〖集金幣〗',
						key: 'recipient_contacts',
						align: 'center',
						sortable: true,
						minWidth: 160
					},
					{
						title: '客戶電話',
						key: 'recipient_phone',
						align: 'center',
						sortable: true,
						minWidth: 130
					},
					{
						title: '出貨單號',
						key: 'odd_numbers',
						slot: 'odd_numbers',
						align: 'center',
						sortable: true,
						minWidth: 150,
					},
					{
						title: '貨架號',
						key: 'shelves',
						align: 'center',
						sortable: true,
						minWidth: 130
					},
					{
						title: '付款狀況',
						key: 'pay_status',
						align: 'center',
						minWidth: 130,
						sortable: true
					},
					// {
					// title: '合計費用',
					// key: 'sum',
					// align: 'center',
					// sortable: true,
					// minWidth: 50,
					// className: 'demo-table-info-cell-name'
					// },
					{
						title: '代收費',
						key: 'amount',
						align: 'center',
						sortable: true,
						minWidth: 50,
						className: 'demo-table-info-cell-name'
					},
					{
						title: '到付運費',
						key: 'freight_collect',
						align: 'center',
						sortable: true,
						minWidth: 50,
						className: 'demo-table-info-cell-name'
					},
					{
						title: '加收附加費',
						key: 'surcharge_price',
						align: 'center',
						sortable: true,
						minWidth: 50,
						className: 'demo-table-info-cell-name'
					},
					{
						title: '立減費',
						key: 'activity',
						align: 'center',
						sortable: true,
						minWidth: 50,
						className: 'demo-table-info-cell-name'
					},
					{
						title: '總費用',
						key: 'sum',
						align: 'center',
						sortable: true,
						minWidth: 50,
						className: 'demo-table-info-cell-name'
					},
					{
						title: '超期費(支付)',
						key: 'outtimepay',
						align: 'center',
						sortable: true,
						minWidth: 50,
						className: 'demo-table-info-column'
					},
					{
						title: '會員積分(支付)',
						key: 'credit',
						align: 'center',
						sortable: true,
						minWidth: 50,
						className: 'demo-table-info-column'
					},
					{
						title: '現金(支付)',
						key: 'cash',
						align: 'center',
						sortable: true,
						minWidth: 50,
						className: 'demo-table-info-column'
					},
					{
						title: '澳門通(支付)',
						key: 'macaupass',
						align: 'center',
						minWidth: 50,
						className: 'demo-table-info-column'
					},
					{
						title: 'Mpay(支付)',
						key: 'mpay',
						align: 'center',
						sortable: true,
						minWidth: 50,
						className: 'demo-table-info-column'
					},
					{
						title: '支付寶(支付)',
						key: 'alipay',
						align: 'center',
						sortable: true,
						minWidth: 50,
						className: 'demo-table-info-column'
					},
					{
						title: '中銀POS(支付)',
						key: 'zyPos',
						align: 'center',
						sortable: true,
						minWidth: 50,
						className: 'demo-table-info-column'
					},
					{
						title: '工商POS(支付)',
						key: 'icbc',
						align: 'center',
						sortable: true,
						minWidth: 50,
						className: 'demo-table-info-column'
					},
					{
						title: '微信(支付)',
						key: 'wxpay',
						align: 'center',
						sortable: true,
						minWidth: 50,
						className: 'demo-table-info-column'
					},
					{
						title: '集金幣(支付)',
						key: 'jpoint',
						align: 'center',
						sortable: true,
						minWidth: 50,
						className: 'demo-table-info-column'
					},
					{
						title: '取貨櫃點',
						key: 'receivingName',
						align: 'center',
						sortable: true,
						minWidth: 150
					},
					{
						title: '袋號',
						key: 'sack_number',
						align: 'center',
						sortable: true,
						minWidth: 130
					},
					{
						title: '品名',
						key: 'productName',
						align: 'center',
						sortable: true,
						minWidth: 130,
					},
					{
						title: '簽收時間',
						key: 'pick_time',
						align: 'center',
						sortable: true,
						minWidth: 160
					},
					{
						title: '備註',
						key: 'remarks',
						align: 'center',
						sortable: true,
						minWidth: 120
					}
				],
				data: []
			},
			table1: {
				column: [
					{
						title: '快遞單號',
						key: 'order',
						align: 'center',
						minWidth: 80
					},
					{
						title: '客戶電話',
						key: 'phone',
						align: 'center',
						minWidth: 80
					},
					{
						title: '客戶名稱',
						key: 'username',
						align: 'center',
						minWidth: 80
					},
				],
				column1: [
					{
						title: '重量',
						key: 'weight',
						align: 'center',
						minWidth: 100
					},
					{
						title: '尺寸',
						key: 'size_sum',
						align: 'center',
						minWidth: 100
					},
					{
						title: '提貨櫃點',
						key: 'store',
						align: 'center',
						minWidth: 100
					},
				],
				column2: [
					{
						title: '快件明細',
						key: 'detailed',
						align: 'center',
						minWidth: 100
					},
					{
						title: '異常件',
						key: 'abnormal',
						align: 'center',
						minWidth: 100
					},
					{
						title: '出庫袋號',
						key: 'sack_number',
						align: 'center',
						minWidth: 100
					},
				],
				column3: [
					{
						title: '最新貨態',
						slot: 'status',
						align: 'center',
						minWidth: 100
					},
					{
						title: '更新時間',
						key: 'created_time',
						align: 'center',
						minWidth: 100
					},
					{
						title: '貨架號',
						key: 'shelves',
						align: 'center',
						minWidth: 100
					},
				],
				column4: [
					{
						title: '代收費',
						key: 'amount',
						align: 'center',
						minWidth: 100
					},
					{
						title: '附加費',
						key: 'surcharge_price',
						align: 'center',
						minWidth: 100
					},
					{
						title: '到附運費',
						key: 'freight_collect',
						align: 'center',
						minWidth: 100
					},
				],
				column5: [
					{
						title: '超期費',
						key: 'outTime_price',
						align: 'center',
						minWidth: 100
					},
					{
						title: '合計費用',
						key: 'total_price',
						align: 'center',
						minWidth: 100
					},
				],
				data: [],
				data1: [],
				data2: [],
				data3: [],
				data4: [],
				data5: [],
			},
			csvData: [],
			json_fields: {
				'客戶名稱': 'name',
				'聯絡電話': 'phone',
				'快遞單號': 'orders',
				'提貨櫃點': 'orderhome',
				'合計費用': 'amountall',
				'到付運費': 'freight_collect',
				'加收附加費': 'additional_fee',
				'超時費': 'overtime_fee',
				'代收費': 'amount',
				'門店立減費': 'discount',
				'會員積分支付': 'credit',
				'現金支付': 'cash',
				'澳門通支付': 'macaupay',
				'Mpay支付': 'mpay',
				'支付寶支付': 'alipay',
				'中銀POS支付': 'boc',
				'工商POS支付': 'icbc',
				'微信': 'wechat',
				'Jpoint': 'jpoint',
				'袋號': 'sack_number',
				'是否線上': 'online_order',
				'是否同城': 'goods_type',
				'订单类型': 'type',
				'簽收時間': 'created_at',
				'備註': 'remark',
				'備註2': 'remarks',
			},
			csvFilename: '已簽收報表',
		};
	},
	created() {
		isthis = this;
		this.getPickAddress();
		this.getSamcityList();
		this.getList();
	},
	mounted() {

	},
	activated() {
		// this.getPickAddress();
		this.getSamcityList();
		// this.getList();
	},
	methods: {
		handleViewOrder(index) {
			this.isShowModalSign_goods = true;
			this.isSubmitingLog = true;
			this.table1.data = []
			this.table1.data1 = []
			this.table1.data2 = []
			this.table1.data3 = []
			this.table1.data4 = []
			this.table1.data5 = []
			let tableData = this.table.data;

			this.$Rq.requestAuth({
				url: this.$Api.all_search,
				method: 'get',
				data: {
					order: tableData[index].odd_numbers
				}
			}).then((res) => {

				let tempArr = [];
				let tempArr1 = [];
				let tempArr2 = [];
				let tempArr3 = [];
				let tempArr4 = [];
				let tempArr5 = [];
				let resData = res.data;

				if (res.code == 0) {
					for (let i = 0; i < resData.data.length; i++) {
						tempArr.push({
							order: resData.data[i].order,
							username: resData.data[i].username,
							phone: resData.data[i].phone,
						});

						tempArr1.push({
							weight: resData.data[i].weight,
							size_sum: resData.data[i].long + 'x' + resData.data[i].width + 'x' + resData.data[i].height,
							store: resData.data[i].store == null ? '- - -' : resData.data[i].store.ReceivingName,
						});

						tempArr2.push({
							sack_number: resData.data[i].sack_number,
							detailed: resData.data[i].detailed == null ? '- - -' : resData.data[i].detailed.name,
							abnormal: resData.data[i].abnormal == 0 ? '否' : '是',
						});

						tempArr3.push({
							shelves: resData.data[i].shelves == null ? '- - -' : resData.data[i].shelves.code,
							status: resData.data[i].status,
							created_time: resData.data[i].created_time,
						});

						tempArr4.push({
							amount: resData.data[i].amount,
							surcharge_price: resData.data[i].surcharge_price,
							freight_collect: resData.data[i].freight_collect,
						});

						tempArr5.push({
							outTime_price: resData.data[i].outTime_price,
							total_price: Number(resData.data[i].surcharge_price) + Number(resData.data[i].outTime_price) + Number(resData.data[i].freight_collect) + Number(resData.data[i].amount),
						});
					}
					this.table1.data = tempArr;
					this.table1.data1 = tempArr1;
					this.table1.data2 = tempArr2;
					this.table1.data3 = tempArr3;
					this.table1.data4 = tempArr4;
					this.table1.data5 = tempArr5;
				}
				this.isSubmitingLog = false;
			}).catch((err) => {
				this.isSubmitingLog = false;
			});

			this.$Rq.requestAuth({
				url: this.$Api.logisticsInfo + '/' + tableData[index].odd_numbers,
				method: 'get',
				data: {}
			}).then((res) => {
				if (Number(res.code) == 0) {
					let resData = res.data;
					let tempArr_log = [];
					let userinfo;

					for (let j = 0; j < resData.length; j++) {
						let datetime = this.getDateTime(resData[j].created_at);

						if (resData[j].userinfos == null) {
							if (resData[j].remarks.match(/[\u606d\u559c\u60a8]/g)) {
								userinfo = '用戶線上支付';
							} else {
								if (resData[i].admin_name != null) {
									userinfo = resData[i].admin_name;
								} else {
									userinfo = '智能櫃派送員';
								}
							}
						} else {
							userinfo = resData[j].userinfos.username;
						}

						tempArr_log.push({
							userinfos: userinfo,
							id: resData[j].id,
							date: datetime.date,
							week: datetime.week,
							time: datetime.time,
							describe: resData[j].remarks
						});
					}

					this.detail = tempArr_log;
				}
			}).catch((err) => {

			});
		},
		getDateTime(datetime) {
			let date = new Date(datetime);
			let year = date.getFullYear();
			let month = date.getMonth() + 1;
			let day = date.getDate();
			let hour = date.getHours();
			let minute = date.getMinutes();
			let second = date.getSeconds();
			let week = date.getDay();
			let weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

			return {
				date: `${this.formateNum_log(year)}-${this.formateNum_log(month)}-${this.formateNum_log(day)}`,
				time: `${this.formateNum_log(hour)}:${this.formateNum_log(minute)}:${this.formateNum_log(second)}`,
				week: weekList[week]
			};
		},

		formateNum_log(num) {
			return num > 9 ? num : '0' + num;
		},
		handleModalSignClose_goods() {
			this.isShowModalSign_goods = false;
		},
		handleViewWuliu(index) {
			let tableData = this.table.data;
			this.$router.push({path: '/shopSignedlogisticsInfo?orderNo=' + tableData[index].odd_numbers});
		},
		handleViewRemark(index) {
			let tableData = this.table.data;
			this.$router.push({path: '/shopSignedRemark?id=' + tableData[index].id});
		},
		getSamcityList() {
			this.$Rq.requestAuth({
				url: this.$Api.samecityUserList,
				method: 'get'
			}).then((res) => {
				if (res.code == 0) {
					this.samcityType = res.data.data;
				}
			});
		},
		getPickAddress() {
			this.$Rq.requestAuth({
				url: this.$Api.pickAddress,
				method: 'get',
				data: {
					company_id: 0,
				}
			}).then((res) => {
				if (res.code == 0) {
					this.pickAddress = res.data.data.filter(it => it.company_id != 15);
					;
					if (res.data.data.length <= 1) {
						this.form.arrive = res.data.data[0].ReceivingID;
					}
				}
			});
		},
		getList() {
			let form = this.form;
			this.isSubmiting = true;

			this.$Rq.requestAuth({
				url: this.$Api.scanIn,
				method: 'get',
				data: {
					status: 4,
					offset: (this.pageIndex - 1) * this.curPageSize,
					limit: this.curPageSize,
					arrive: form.arrive,
					start_time: this.formatDate(form.start_time),
					end_time: this.formatDate(form.end_time),
					odd_numbers: form.odd_numbers,
					phone: form.phone,
					sack_number: form.sack_number,
					username: form.username,
					pay_type: form.pay_type,
					// order_parent: form.order_parent
				}
			}).then((res) => {
				this.isSubmiting = false;
				try {
					if (res.code == 0) {
						let tempArr = [];
						let class_pay_type = [];
						let resData = res.data.data;

						for (let i = 0; i < resData.length; i++) {
							let integral_tw = 0;
							let orderamount_additional_fee;
							let orderamount_credit;
							let orderamount_cash;
							let orderamount_alipay;
							let orderamount_macaupass;
							let orderamount_mpay;
							let orderamount_zyPos;
							let orderamount_icbc;
							let orderamount_wxpay;
							let orderamount_jpoint;
							let orderamount_overtime_fee;
							let order_type;
							let order_online;

							const tws = resData[i].user?.tw?.length || 0

							for (let j = 0; j < tws || 0; j++) {
								const iisa = resData[i].user?.tw[j]?.integral
								let integral_tw_count = Number(iisa || 0);
								integral_tw += integral_tw_count;
							}

							if (resData[i].pay_status == 0) {
								resData[i].pay_status = '未付款';
							} else {
								resData[i].pay_status = '已付款';
							}

							if (resData[i].pay_type == 0) {
								class_pay_type[i] = '';
							} else {
								class_pay_type[i] = 'demo-table-app-row';
							}

							if (resData[i].orderamount != null) {

								order_type = '新';

								if (resData[i].orderamount.additional_fee == 0 || resData[i].orderamount.additional_fee == null) {
									orderamount_additional_fee = 0;
								} else {
									orderamount_additional_fee = resData[i].orderamount.additional_fee;
								}

								if (resData[i].orderamount.overtime_fee == 0 || resData[i].orderamount.overtime_fee == null) {
									orderamount_overtime_fee = 0;
								} else {
									orderamount_overtime_fee = resData[i].orderamount.overtime_fee;
								}

								if (resData[i].orderamount.order_online == 1) { //積分

									order_online = '二次/積分';

									if (resData[i].orderamount.credit == null) {
										orderamount_credit = Number(0);
									} else {
										orderamount_credit = Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw);
									}

									if (resData[i].orderamount.cash > 0) {
										orderamount_cash = Number(resData[i].orderamount.cash + resData[i].orderamount.overtime_fee);
									} else {
										orderamount_cash = 0;
									}

									if (resData[i].orderamount.alipay > 0) {
										orderamount_alipay = Number(resData[i].orderamount.alipay + resData[i].orderamount.overtime_fee);
									} else {
										orderamount_alipay = 0;
									}

									if (resData[i].orderamount.macaupay > 0) {
										orderamount_macaupass = Number(resData[i].orderamount.macaupay + resData[i].orderamount.overtime_fee);
									} else {
										orderamount_macaupass = 0;
									}

									if (resData[i].orderamount.mpay > 0) {
										orderamount_mpay = Number(resData[i].orderamount.mpay + resData[i].orderamount.overtime_fee);
									} else {
										orderamount_mpay = 0;
									}

									if (resData[i].orderamount.boc > 0) {
										orderamount_zyPos = Number(resData[i].orderamount.boc + resData[i].orderamount.overtime_fee);
									} else {
										orderamount_zyPos = 0;
									}

									if (resData[i].orderamount.icbc > 0) {
										orderamount_icbc = Number(resData[i].orderamount.icbc + resData[i].orderamount.overtime_fee);
									} else {
										orderamount_icbc = 0;
									}

									if (resData[i].orderamount.wechat > 0) {
										orderamount_wxpay = Number(resData[i].orderamount.wechat + resData[i].orderamount.overtime_fee);
									} else {
										orderamount_wxpay = 0;
									}

									if (resData[i].orderamount.jpoint > 0) {
										orderamount_jpoint = Number(resData[i].orderamount.jpoint + resData[i].orderamount.overtime_fee);
									} else {
										orderamount_jpoint = 0;
									}
								}

								if (resData[i].orderamount.order_online == 2) { //中銀

									order_online = '二次/中銀';

									if (resData[i].orderamount.boc == null) {
										orderamount_zyPos = Number(0);
									} else {
										orderamount_zyPos = Number(resData[i].orderamount.boc);
									}

									if (Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0) {
										orderamount_credit = Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw);
									} else {
										orderamount_credit = 0;
									}

									if (resData[i].orderamount.cash > 0) {
										orderamount_cash = Number(resData[i].orderamount.cash);
									} else {
										orderamount_cash = 0;
									}

									if (resData[i].orderamount.alipay > 0) {
										orderamount_alipay = Number(resData[i].orderamount.alipay);
									} else {
										orderamount_alipay = 0;
									}

									if (resData[i].orderamount.macaupay > 0) {
										orderamount_macaupass = Number(resData[i].orderamount.macaupay);
									} else {
										orderamount_macaupass = 0;
									}

									if (resData[i].orderamount.mpay > 0) {
										orderamount_mpay = Number(resData[i].orderamount.mpay);
									} else {
										orderamount_mpay = 0;
									}

									if (resData[i].orderamount.icbc > 0) {
										orderamount_icbc = Number(resData[i].orderamount.icbc);
									} else {
										orderamount_icbc = 0;
									}

									if (resData[i].orderamount.wechat > 0) {
										orderamount_wxpay = Number(resData[i].orderamount.wechat);
									} else {
										orderamount_wxpay = 0;
									}

									if (resData[i].orderamount.jpoint > 0) {
										orderamount_jpoint = Number(resData[i].orderamount.jpoint);
									} else {
										orderamount_jpoint = 0;
									}
								}

								if (resData[i].orderamount.order_online == 3) { //工銀

									order_online = '二次/工銀';

									if (resData[i].orderamount.icbc == null) {
										orderamount_icbc = Number(0);
									} else {
										orderamount_icbc = Number(resData[i].orderamount.icbc);
									}

									if (Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0) {
										orderamount_credit = Number(resData[i].orderamount.credit) + Number(resData[i].orderamount.credit_tw);
									} else {
										orderamount_credit = 0;
									}

									if (resData[i].orderamount.cash > 0) {
										orderamount_cash = Number(resData[i].orderamount.cash);
									} else {
										orderamount_cash = 0;
									}

									if (resData[i].orderamount.alipay > 0) {
										orderamount_alipay = Number(resData[i].orderamount.alipay);
									} else {
										orderamount_alipay = 0;
									}

									if (resData[i].orderamount.macaupay > 0) {
										orderamount_macaupass = Number(resData[i].orderamount.macaupay);
									} else {
										orderamount_macaupass = 0;
									}

									if (resData[i].orderamount.mpay > 0) {
										orderamount_mpay = Number(resData[i].orderamount.mpay);
									} else {
										orderamount_mpay = 0;
									}

									if (resData[i].orderamount.boc > 0) {
										orderamount_zyPos = Number(resData[i].orderamount.boc);
									} else {
										orderamount_zyPos = 0;
									}

									if (resData[i].orderamount.wechat > 0) {
										orderamount_wxpay = Number(resData[i].orderamount.wechat);
									} else {
										orderamount_wxpay = 0;
									}
								}

								if (resData[i].orderamount.order_online == 4) { //微信

									order_online = '二次/微信';

									if (resData[i].orderamount.wechat == null) {
										orderamount_wxpay = Number(0);
									} else {
										orderamount_wxpay = Number(resData[i].orderamount.wechat);
									}

									if (Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0) {
										orderamount_credit = Number(resData[i].orderamount.credit) + Number(resData[i].orderamount.credit_tw);
									} else {
										orderamount_credit = 0;
									}

									if (resData[i].orderamount.cash > 0) {
										orderamount_cash = Number(resData[i].orderamount.cash);
									} else {
										orderamount_cash = 0;
									}

									if (resData[i].orderamount.alipay > 0) {
										orderamount_alipay = Number(resData[i].orderamount.alipay);
									} else {
										orderamount_alipay = 0;
									}

									if (resData[i].orderamount.macaupay > 0) {
										orderamount_macaupass = Number(resData[i].orderamount.macaupay);
									} else {
										orderamount_macaupass = 0;
									}

									if (resData[i].orderamount.mpay > 0) {
										orderamount_mpay = Number(resData[i].orderamount.mpay);
									} else {
										orderamount_mpay = 0;
									}

									if (resData[i].orderamount.boc > 0) {
										orderamount_zyPos = Number(resData[i].orderamount.boc);
									} else {
										orderamount_zyPos = 0;
									}

									if (resData[i].orderamount.icbc > 0) {
										orderamount_icbc = Number(resData[i].orderamount.icbc);
									} else {
										orderamount_icbc = 0;
									}

									if (resData[i].orderamount.jpoint > 0) {
										orderamount_jpoint = Number(resData[i].orderamount.jpoint);
									} else {
										orderamount_jpoint = 0;
									}
								}

								if (resData[i].orderamount.order_online == 5) { //Mpay

									order_online = '二次/Mpay';

									if (resData[i].orderamount.mpay == null) {
										orderamount_mpay = Number(0);
									} else {
										orderamount_mpay = Number(resData[i].orderamount.mpay);
									}

									if (Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0) {
										orderamount_credit = Number(resData[i].orderamount.credit) + Number(resData[i].orderamount.credit_tw);
									} else {
										orderamount_credit = 0;
									}

									if (resData[i].orderamount.cash > 0) {
										orderamount_cash = Number(resData[i].orderamount.cash);
									} else {
										orderamount_cash = 0;
									}

									if (resData[i].orderamount.alipay > 0) {
										orderamount_alipay = Number(resData[i].orderamount.alipay);
									} else {
										orderamount_alipay = 0;
									}

									if (resData[i].orderamount.macaupay > 0) {
										orderamount_macaupass = Number(resData[i].orderamount.macaupay);
									} else {
										orderamount_macaupass = 0;
									}

									if (resData[i].orderamount.boc > 0) {
										orderamount_zyPos = Number(resData[i].orderamount.boc);
									} else {
										orderamount_zyPos = 0;
									}

									if (resData[i].orderamount.icbc > 0) {
										orderamount_icbc = Number(resData[i].orderamount.icbc);
									} else {
										orderamount_icbc = 0;
									}

									if (resData[i].orderamount.wechat > 0) {
										orderamount_wxpay = Number(resData[i].orderamount.wechat);
									} else {
										orderamount_wxpay = 0;
									}

									if (resData[i].orderamount.jpoint > 0) {
										orderamount_jpoint = Number(resData[i].orderamount.jpoint);
									} else {
										orderamount_jpoint = 0;
									}
								}

								if (resData[i].orderamount.order_online == 6) { //澳門通
									order_online = '二次/澳門通';

									if (resData[i].orderamount.macaupass == null) {
										orderamount_macaupass = Number(0);
									} else {
										orderamount_macaupass = Number(resData[i].orderamount.macaupass);
									}

									if (Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0) {
										orderamount_credit = Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw);
									} else {
										orderamount_credit = 0;
									}

									if (resData[i].orderamount.cash > 0) {
										orderamount_cash = Number(resData[i].orderamount.cash);
									} else {
										orderamount_cash = 0;
									}

									if (resData[i].orderamount.alipay > 0) {
										orderamount_alipay = Number(resData[i].orderamount.alipay);
									} else {
										orderamount_alipay = 0;
									}

									if (resData[i].orderamount.mpay > 0) {
										orderamount_mpay = Number(resData[i].orderamount.mpay);
									} else {
										orderamount_mpay = 0;
									}

									if (resData[i].orderamount.boc > 0) {
										orderamount_zyPos = Number(resData[i].orderamount.boc);
									} else {
										orderamount_zyPos = 0;
									}

									if (resData[i].orderamount.icbc > 0) {
										orderamount_icbc = Number(resData[i].orderamount.icbc);
									} else {
										orderamount_icbc = 0;
									}

									if (resData[i].orderamount.wechat > 0) {
										orderamount_wxpay = Number(resData[i].orderamount.wechat);
									} else {
										orderamount_wxpay = 0;
									}

									if (resData[i].orderamount.jpoint > 0) {
										orderamount_jpoint = Number(resData[i].orderamount.jpoint);
									} else {
										orderamount_jpoint = 0;
									}
								}

								if (resData[i].orderamount.order_online == 7) { //Alipay

									order_online = '二次/支付寶';

									if (resData[i].orderamount.alipay == null) {
										orderamount_alipay = Number(0);
									} else {
										orderamount_alipay = Number(resData[i].orderamount.alipay);
									}

									if (Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0) {
										orderamount_credit = Number(resData[i].orderamount.credit) + Number(resData[i].orderamount.credit_tw);
									} else {
										orderamount_credit = 0;
									}

									if (resData[i].orderamount.cash > 0) {
										orderamount_cash = Number(resData[i].orderamount.cash);
									} else {
										orderamount_cash = 0;
									}

									if (resData[i].orderamount.macaupay > 0) {
										orderamount_macaupass = Number(resData[i].orderamount.macaupay);
									} else {
										orderamount_macaupass = 0;
									}

									if (resData[i].orderamount.mpay > 0) {
										orderamount_mpay = Number(resData[i].orderamount.mpay);
									} else {
										orderamount_mpay = 0;
									}

									if (resData[i].orderamount.boc > 0) {
										orderamount_zyPos = Number(resData[i].orderamount.boc);
									} else {
										orderamount_zyPos = 0;
									}

									if (resData[i].orderamount.icbc > 0) {
										orderamount_icbc = Number(resData[i].orderamount.icbc);
									} else {
										orderamount_icbc = 0;
									}

									if (resData[i].orderamount.wechat > 0) {
										orderamount_wxpay = Number(resData[i].orderamount.wechat);
									} else {
										orderamount_wxpay = 0;
									}

									if (resData[i].orderamount.jpoint > 0) {
										orderamount_jpoint = Number(resData[i].orderamount.jpoint);
									} else {
										orderamount_jpoint = 0;
									}
								}

								if (resData[i].orderamount.order_online == 8) { //現金

									order_online = '二次/現金';

									orderamount_cash = Number(resData[i].orderamount.cash);

									if (Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0) {
										orderamount_credit = Number(resData[i].orderamount.credit) + Number(resData[i].orderamount.credit_tw);
									} else {
										orderamount_credit = 0;
									}

									if (resData[i].orderamount.alipay > 0) {
										orderamount_alipay = Number(resData[i].orderamount.alipay);
									} else {
										orderamount_alipay = 0;
									}

									if (resData[i].orderamount.macaupay > 0) {
										orderamount_macaupass = Number(resData[i].orderamount.macaupay);
									} else {
										orderamount_macaupass = 0;
									}

									if (resData[i].orderamount.mpay > 0) {
										orderamount_mpay = Number(resData[i].orderamount.mpay);
									} else {
										orderamount_mpay = 0;
									}

									if (resData[i].orderamount.boc > 0) {
										orderamount_zyPos = Number(resData[i].orderamount.boc);
									} else {
										orderamount_zyPos = 0;
									}

									if (resData[i].orderamount.icbc > 0) {
										orderamount_icbc = Number(resData[i].orderamount.icbc);
									} else {
										orderamount_icbc = 0;
									}

									if (resData[i].orderamount.wechat > 0) {
										orderamount_wxpay = Number(resData[i].orderamount.wechat);
									} else {
										orderamount_wxpay = 0;
									}

									if (resData[i].orderamount.jpoint > 0) {
										orderamount_jpoint = Number(resData[i].orderamount.jpoint);
									} else {
										orderamount_jpoint = 0;
									}
								}

								if (resData[i].orderamount.order_online == 9) { //集金幣

									order_online = '二次/集金幣';

									orderamount_jpoint = Number(resData[i].orderamount.jpoint);

									if (Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0) {
										orderamount_credit = Number(resData[i].orderamount.credit) + Number(resData[i].orderamount.credit_tw);
									} else {
										orderamount_credit = 0;
									}

									if (resData[i].orderamount.cash > 0) {
										orderamount_cash = Number(resData[i].orderamount.cash);
									} else {
										orderamount_cash = 0;
									}

									if (resData[i].orderamount.alipay > 0) {
										orderamount_alipay = Number(resData[i].orderamount.alipay);
									} else {
										orderamount_alipay = 0;
									}

									if (resData[i].orderamount.macaupay > 0) {
										orderamount_macaupass = Number(resData[i].orderamount.macaupay);
									} else {
										orderamount_macaupass = 0;
									}

									if (resData[i].orderamount.mpay > 0) {
										orderamount_mpay = Number(resData[i].orderamount.mpay);
									} else {
										orderamount_mpay = 0;
									}

									if (resData[i].orderamount.boc > 0) {
										orderamount_zyPos = Number(resData[i].orderamount.boc);
									} else {
										orderamount_zyPos = 0;
									}

									if (resData[i].orderamount.icbc > 0) {
										orderamount_icbc = Number(resData[i].orderamount.icbc);
									} else {
										orderamount_icbc = 0;
									}

									if (resData[i].orderamount.wechat > 0) {
										orderamount_wxpay = Number(resData[i].orderamount.wechat);
									} else {
										orderamount_wxpay = 0;
									}

									if (resData[i].orderamount.jpoint > 0) {
										orderamount_jpoint = Number(resData[i].orderamount.jpoint);
									} else {
										orderamount_jpoint = 0;
									}
								}

								if (resData[i].orderamount.order_online == null || resData[i].orderamount.order_online == 0) //NULL
								{
									order_online = '一次';

									if (Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0) {
										orderamount_credit = Number(resData[i].orderamount.credit) + Number(resData[i].orderamount.credit_tw);
									} else {
										orderamount_credit = 0;
									}

									if (resData[i].orderamount.cash > 0) {
										// orderamount_cash = Number(resData[i].orderamount.cash + resData[i].orderamount.overtime_fee);
										orderamount_cash = Number(resData[i].orderamount.cash);
									} else {
										orderamount_cash = 0;
									}

									if (resData[i].orderamount.alipay > 0) {
										// orderamount_alipay = Number(resData[i].orderamount.alipay + resData[i].orderamount.overtime_fee);
										orderamount_alipay = Number(resData[i].orderamount.alipay);
									} else {
										orderamount_alipay = 0;
									}

									if (resData[i].orderamount.macaupay > 0) {
										orderamount_macaupass = Number(resData[i].orderamount.macaupay);
									} else {
										orderamount_macaupass = 0;
									}

									if (resData[i].orderamount.mpay > 0) {
										orderamount_mpay = Number(resData[i].orderamount.mpay);
									} else {
										orderamount_mpay = 0;
									}

									if (resData[i].orderamount.boc > 0) {
										orderamount_zyPos = Number(resData[i].orderamount.boc);
									} else {
										orderamount_zyPos = 0;
									}

									if (resData[i].orderamount.icbc > 0) {
										orderamount_icbc = Number(resData[i].orderamount.icbc);
									} else {
										orderamount_icbc = 0;
									}

									if (resData[i].orderamount.wechat > 0) {
										orderamount_wxpay = Number(resData[i].orderamount.wechat);
									} else {
										orderamount_wxpay = 0;
									}

									if (resData[i].orderamount.jpoint > 0) {
										orderamount_jpoint = Number(resData[i].orderamount.jpoint);
									} else {
										orderamount_jpoint = 0;
									}
								}


								let order_online_overtime = '';

								if (resData[i].orderamount.order_online == 1) {
									order_online_overtime = '積分';
								}
								if (resData[i].orderamount.order_online == 2) {
									order_online_overtime = '中銀';
								}
								if (resData[i].orderamount.order_online == 3) {
									order_online_overtime = '工銀';
								}
								if (resData[i].orderamount.order_online == 4) {
									order_online_overtime = '微信';
								}
								if (resData[i].orderamount.order_online == 5) {
									order_online_overtime = 'Mpay';
								}
								if (resData[i].orderamount.order_online == 6) {
									order_online_overtime = '澳門通';
								}
								if (resData[i].orderamount.order_online == 7) {
									order_online_overtime = '支付寶';
								}
								if (resData[i].orderamount.order_online == 8) {
									order_online_overtime = '現金';
								}
								if (resData[i].orderamount.order_online == 9) {
									order_online_overtime = '集金幣';
								}

								let arrive_type_cabinet = resData[i].arrive_type == null ? 0 : resData[i].arrive_type;

								if (arrive_type_cabinet == 2) {
									tempArr.push({

										id: resData[i].id,

										recipient_contacts: resData[i].recipient_contacts + '【' + (resData[i].user?.user_integral + integral_tw) + '】' + '〖' + (resData[i].user.jpoint == null ? 0 : Number(resData[i].user.jpoint / 100)) + '〗', //客戶名稱【積分】

										recipient_phone: resData[i].recipient_phone, //客戶電話

										productName: resData[i].detailed.name, //品名

										odd_numbers: resData[i].odd_numbers, //出貨單號

										sack_number: resData[i].sack_number, //袋號

										receivingName: resData[i].store == null ? '- - -' : resData[i].store.ReceivingName, //取貨櫃點

										shelves: resData[i].shelves == null ? '- - -' : resData[i].shelves.code, //貨架號

										pay_status: resData[i].pay_status, //付款状况

										pick_time: resData[i].pick_time, // 簽收時間

										freight_collect: Number(resData[i].freight_collect), // 代收费和合计

										// surcharge_price: resData[i].orderamount.additional_fee ? resData[i].orderamount.additional_fee : 0, // 附加費

										surcharge_price: Number(resData[i].surcharge_price), // 附加費

										amount: Number(resData[i].amount), // 代收費

										sum: resData[i].orderamount.allamount ? Number(resData[i].orderamount.allamount) + Number(resData[i].surcharge_price) + Number(resData[i].freight_collect) : 0 + Number(resData[i].surcharge_price) + Number(resData[i].freight_collect),

										// outtimepay: resData[i].orderamount.overtime_fee ? resData[i].orderamount.overtime_fee + '(' + order_online_overtime + ')': 0, //超期費
										outtimepay: '- - -',

										activity: resData[i].orderamount.discount == 0 ? '無立減' : '-' + resData[i].orderamount.discount, // 立減3元

										remarks: resData[i].remarks, // 備註

										additional_fee: orderamount_additional_fee, // 附加費

										credit: '- - -', //已簽收-積分

										cash: '- - -', //已簽收-現金

										alipay: '- - -', //已簽收-支付寶

										macaupass: '- - -', //已簽收-澳門通

										mpay: '- - -', //已簽收-澳門錢包

										zyPos: '- - -', //已簽收-中銀

										icbc: '- - -', //已簽收-工銀

										wxpay: '- - -', //已簽收-微信

										jpoint: '- - -', //已簽收-Jpoint

										order_type: order_type, //新或舊

										order_online: order_online,

										pay_type: resData[i].pay_type == 0 ? '未在APP內付款' : '已在APP內付款', //付款状况
									});
								} else {
									tempArr.push({

										id: resData[i].id,

										recipient_contacts: resData[i].recipient_contacts + '【' + (resData[i].user?.user_integral + integral_tw) + '】' + '〖' + (resData[i].user.jpoint == null ? 0 : Number(resData[i].user.jpoint / 100)) + '〗', //客戶名稱【積分】

										recipient_phone: resData[i].recipient_phone, //客戶電話

										productName: resData[i].detailed.name, //品名

										odd_numbers: resData[i].odd_numbers, //出貨單號

										sack_number: resData[i].sack_number, //袋號

										receivingName: resData[i].store == null ? '- - -' : resData[i].store.ReceivingName, //取貨櫃點

										shelves: resData[i].shelves == null ? '- - -' : resData[i].shelves.code, //貨架號

										pay_status: resData[i].pay_status, //付款状况

										pick_time: resData[i].pick_time, // 簽收時間

										freight_collect: Number(resData[i].freight_collect), // 代收费和合计

										// surcharge_price: resData[i].orderamount.additional_fee ? resData[i].orderamount.additional_fee : 0, // 附加費

										surcharge_price: Number(resData[i].surcharge_price), // 附加費

										amount: Number(resData[i].amount), // 代收費

										sum: resData[i].orderamount.allamount ? Number(resData[i].orderamount.allamount) : 0,

										outtimepay: resData[i].orderamount.overtime_fee ? resData[i].orderamount.overtime_fee + '(' + order_online_overtime + ')' : 0, //超期費

										activity: resData[i].orderamount.discount == 0 ? '無立減' : '-' + resData[i].orderamount.discount, // 立減3元

										remarks: resData[i].remarks, // 備註

										additional_fee: orderamount_additional_fee, // 附加費

										credit: orderamount_credit, //已簽收-積分

										cash: orderamount_cash, //已簽收-現金

										alipay: orderamount_alipay, //已簽收-支付寶

										macaupass: orderamount_macaupass, //已簽收-澳門通

										mpay: orderamount_mpay, //已簽收-澳門錢包

										zyPos: orderamount_zyPos, //已簽收-中銀

										icbc: orderamount_icbc, //已簽收-工銀

										wxpay: orderamount_wxpay, //已簽收-微信

										jpoint: orderamount_jpoint, //已簽收-Jpoint

										order_type: order_type, //新或舊

										order_online: order_online,

										pay_type: resData[i].pay_type == 0 ? '未在APP內付款' : '已在APP內付款', //付款状况
									});
								}
							} else {
								order_type = '舊';

								tempArr.push({

									id: resData[i].id,

									recipient_contacts: resData[i].recipient_contacts + '【' + (resData[i].user?.user_integral + integral_tw) + '】', //客戶名稱【積分】

									recipient_phone: resData[i].recipient_phone, //客戶電話

									productName: resData[i].detailed.name, //品名

									odd_numbers: resData[i].odd_numbers, //出貨單號

									sack_number: resData[i].sack_number, //袋號

									receivingName: resData[i].store == null ? '- - -' : resData[i].store.ReceivingName, //取貨櫃點

									shelves: resData[i].shelves == null ? '- - -' : resData[i].shelves.code, //貨架號

									pay_status: resData[i].pay_status, //付款状况

									pick_time: resData[i].pick_time, // 簽收時間

									freight_collect: Number(resData[i].freight_collect), // 代收费和合计

									surcharge_price: Number(resData[i].surcharge_price), // 附加费

									amount: Number(resData[i].amount), // 代收費

									sum: Number(resData[i].freight_collect) + Number(resData[i].surcharge_price) + Number(resData[i].amount) + Number(resData[i].outtimepay), //合計費用

									outtimepay: resData[i].outtimepay ? resData[i].outtimepay : 0, //超期費

									activity: resData[i].store == null ? '0' : '-' + resData[i].store.offline_activity, // 立減3元

									remarks: resData[i].remarks, // 備註

									credit: resData[i].credit ? resData[i].credit : 0,

									cash: resData[i].cash ? resData[i].cash : 0,

									alipay: resData[i].alipay ? resData[i].alipay : 0,

									macaupass: resData[i].macaupass ? resData[i].macaupass : 0,

									mpay: resData[i].mpay ? resData[i].mpay : 0,

									zyPos: resData[i].zyPos ? resData[i].zyPos : 0,

									icbc: resData[i].icbc ? resData[i].icbc : 0,

									wxpay: resData[i].wxpay ? resData[i].wxpay : 0,

									jpoint: resData[i].jpoint ? resData[i].jpoint : 0,

									order_type: order_type,

									order_online: '舊'
								});
							}
						}

						this.totalCount = res.data.count;
						this.table.data = tempArr;
					} else {
						this.showTipInfo(res.msg);
					}
				} catch (e) {
					console.log(e)
				}
				console.log(this.table.data)
			}).catch((err) => {
				this.isSubmiting = false;
			});
		},
		handleSearch() {
			this.pageIndex = 1;
			isthis.sums = 0;
			this.getList();
		},
		formatDate(datetime) {
			if (!datetime) return '';
			let dateTime = new Date(datetime);
			let year = dateTime.getFullYear();
			let month = dateTime.getMonth() + 1;
			let date = dateTime.getDate();
			let hour = dateTime.getHours();
			let minute = dateTime.getMinutes();
			let second = dateTime.getSeconds();
			let milliseconds = dateTime.getMilliseconds();
			return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
		},
		formatNum(num) {
			return num < 10 ? '0' + num : num;
		},
		handleExport() {
			let token = localStorage.getItem('jyb_token');
			let form = this.form;
			let params = {};

			if (form.arrive == 0) {
				params = {
					'Authorization': token,
					status: 4,
					odd_numbers: form.odd_numbers,
					sack_number: form.sack_number,
					phone: form.phone,
					username: form.username,
					start_time: this.formatDate(form.start_time),
					end_time: this.formatDate(form.end_time)
				};
			} else {
				params = {
					'Authorization': token,
					status: 4,
					arrive: form.arrive,
					odd_numbers: form.odd_numbers,
					sack_number: form.sack_number,
					phone: form.phone,
					username: form.username,
					start_time: this.formatDate(form.start_time),
					end_time: this.formatDate(form.end_time)
				};
			}

			let formatParams = this.$Utils.formateObjToParamStr(params);
			if (form.start_time == '') {
				this.$Utils.showTipInfo("請選擇起始時間");
			} else if (form.end_time == '') {
				this.$Utils.showTipInfo("請選擇結束時間");
			}
				// else if(form.arrive == ''){
				//     this.$Utils.showTipInfo("請選擇門店或智能櫃");
			// }
			else {
				this.getList();
				window.open(`${this.$Api.deliverExport}?${formatParams}`, '_blank');
			}
		},

		filterCon(val) {
			let count = 0, sum = 0,pddsum = 0, insum = 0, i = 0, freight_collect = 0, weight = 0;

			for (i; i < val.length; i++) {
				const data = val[i];

				sum = sum + (parseFloat(data.amountall) || 0);
				pddsum = pddsum + (parseFloat(data.pddamount) || 0);
				freight_collect = freight_collect + (parseFloat(data.freight_collect) || 0)
				weight = weight + (parseFloat(data.weight) || 0)

				insum = insum + parseFloat(data.credit || 0) +
					parseFloat(data.cash || 0) + parseFloat(data.macaupay || 0) +
					parseFloat(data.mpay || 0) + parseFloat(data.alipay || 0) +
					parseFloat(data.boc || 0) + parseFloat(data.icbc || 0) +
					parseFloat(data.wechat || 0) + parseFloat(data.jpoint || 0);
			}
			return {
				count: i, sum, pddsum, insum, freight_collect, weight
			}
		},
		calculateShippingCost(weight = 0, firstWeightCost = 0, additionalWeightCost = 0, additionalWeightUnit = 0) {
			// 检查入参是否为有效的数字
			if (typeof weight !== 'number' || isNaN(weight)) {
				return 0; // 非数字输入返回0
			}

			// 处理负重情况
			if (weight < 0) {
				return 0; // 负重返回0
			}

			let totalCost = firstWeightCost; // 首重费用

			// 如果重量大于首重单位，计算续重费用
			if (weight > additionalWeightUnit) {
				const additionalWeight = Math.ceil((weight - additionalWeightUnit) / additionalWeightUnit); // 续重部分
				totalCost += additionalWeight * additionalWeightCost; // 加上续重费用
			}

			return totalCost;
		},
		handleExport_zh() {
			if (this.isLoadExcel) {
				return this.$Utils.showTipInfo("正在下載報表，請稍等");
			}
			console.log('导出')
			let token = localStorage.getItem('jyb_token');
			let form = this.form;
			if (!form.start_time || !form.end_time) {
				return this.$Utils.showTipInfo("請選擇導出時間");
			}
			this.isSubmiting = true;
			this.isLoadExcel = true;

			/*if (form.arrive == 0) {
			 params = {
			 'Authorization': token,
			 status: 4,
			 odd_numbers: form.odd_numbers,
			 sack_number: form.sack_number,
			 phone: form.phone,
			 username: form.username,
			 start_time: this.formatDate(form.start_time),
			 end_time: this.formatDate(form.end_time)
			 };
			 } else {
			 params = {
			 'Authorization': token,
			 status: 4,
			 arrive: form.arrive,
			 odd_numbers: form.odd_numbers,x
			 sack_number: form.sack_number,
			 phone: form.phone,
			 username: form.username,
			 start_time: this.formatDate(form.start_time),
			 end_time: this.formatDate(form.end_time)
			 };
			 }

			 let formatParams = this.$Utils.formateObjToParamStr(params);
			 window.open(`${this.$Api.deliverExport_zh}?${formatParams}`, '_blank');*/
			const datas = {
				status: 4,  //0待出库, 1已出库
				odd_numbers: form.odd_numbers,
				sack_number: form.sack_number,
				phone: form.phone,
				arrive: form.arrive,
				username: form.username,
				start_time: this.formatDate(form.start_time),
				end_time: this.formatDate(form.end_time)
			}
			if (form.arrive == 0) {
				delete datas.arrive
			}

			this.$Rq.requestAuth({
				url: this.$Api.deliverExport,
				method: 'get',
				data: datas
			}).then(res => {
				console.log(res)

				if (res.code === 0) {
					this.$Utils.showSuccess(res.msg)
					const data = res.data.data.map(item => {
						const freight_collect = item.freight_collect
						const discount = item.discount
						item.freight_collect = parseFloat(freight_collect) || 0
						item.discount = parseFloat(discount) || 0
						return item
					}).filter(it => {
						if (it.stype == '普通包裹' || !it.stype) {
							return it;
						}
					})

					const data2 = res.data.data.map(item => {
						const freight_collect = item.freight_collect
						const discount = item.discount
						item.freight_collect = parseFloat(freight_collect) || 0
						item.discount = parseFloat(discount) || 0
						return item
					}).filter(it => it.stype == '拼多多包裹')

					const courier = {
						jyb: {
							firstWeightCost: 2.3,// 首重费用
							additionalWeightCost: 0.7,// 续重费用
							additionalWeightUnit: 1// 续重单位
						},
						ej: {
							firstWeightCost: 2.4,
							additionalWeightCost: 0.6,
							additionalWeightUnit: 0.5
						},
						lt: {
							firstWeightCost: 2.7,
							additionalWeightCost: 0.9,
							additionalWeightUnit: 0.5
						},
						al: {
							firstWeightCost: 2.5,
							additionalWeightCost: 0.6,
							additionalWeightUnit: 0.5
						}
					}

					const courierMapping = {
						1: courier.jyb,
						27: courier.ej,
						30: courier.lt,
						33: courier.al
					};

					const data3 = data2.map(item => {
						const parend_id = item.company_id;
						// 計算運費
						item.weight = parseFloat(item.weight) || 0;
						item.amountall = parseFloat(item.amountall) || 0;
						const currentCourier = courierMapping[parend_id] || courier.jyb;
						const shippingCost = this.calculateShippingCost(
							item.weight,
							currentCourier.firstWeightCost,
							currentCourier.additionalWeightCost,
							currentCourier.additionalWeightUnit,
						);
						item.pddamount = parseFloat(shippingCost) || 0;
						item.amountall = item.amountall + item.pddamount;


						// 区分公司
						// 區分門店類型
						const companys = this.samcityType;
						const company = companys.find(it => it.id == parend_id);
						item.company = company.name; // 公司名稱
						if (parend_id == 27)  {
							item.arrive_type = '加盟商'

              // 判断日期并返回相应的处理结果
              const comparisonDate = dayjs('2025-01-16');
              const currentDate = dayjs(item.created_at);
              if (currentDate.isAfter(comparisonDate)) {
                //日期大于2025年1月16号的处理方式';
                item.pddamount = item.pddamount + 0.2;
                item.amountall = item.amountall + 0.2;
              }
						}else if (parend_id == 30) {
							item.arrive_type = '加盟商'
						}else if(parend_id == 33) {
							item.arrive_type = '加盟商'
						}

						return item;
					})


					const table = [{
						sheet: '已簽收明細(普通)',
						columns: [
							{label: "用户", value: "name"},
							{label: "聯絡電話", value: "phone"},
							{label: "快遞單號", value: "orders"},
							{label: "提貨櫃點", value: "orderhome"},
							{label: "合計費用", value: "amountall"},
							{label: "到付運費", value: "freight_collect"},
							{label: "加收附加費", value: "additional_fee"},
							{label: "超時費", value: "overtime_fee"},
							{label: "代收費", value: "amount"},
							{label: "門店立減費", value: "discount"},
							{label: "會員積分支付", value: "credit"},
							{label: "現金支付", value: "cash"},
							{label: "澳門通支付", value: "macaupay"},
							{label: "Mpay支付", value: "mpay"},
							{label: "支付寶支付", value: "alipay"},
							{label: "中銀POS支付", value: "boc"},
							{label: "工商POS支付", value: "icbc"},
							{label: "微信", value: "wechat"},
							{label: "Jpoint", value: "jpoint"},
							{label: "袋號", value: "sack_number"},
							{label: "是否線上", value: "online_order"},
							{label: "是否同城", value: "goods_type"},
							{label: "订单类型", value: "type"},
							{label: "包裹类型", value: "stype"},
							{label: "櫃店類型", value: "arrive_type"},
							{label: "簽收時間", value: "created_at"},
							{label: "備註", value: "remark"},
							{label: "備註2", value: "remarks"},
						],
						content: data
					}, {
						sheet: '已簽收總覽(普通)',
						columns: [
							{label: "縂件數", value: "count"},
							{label: "合計費用", value: "sum"},
							{label: "已收總計", value: "insum"},
							{label: "到付費用", value: "freight_collect"},
						],
						content: [
							{
								count: this.filterCon(data).count,
								sum: this.filterCon(data).sum,
								insum: this.filterCon(data).insum,
								freight_collect: this.filterCon(data).freight_collect
							},
						]
					}, {
						sheet: '已簽收明細(拼多多)',
						columns: [
							{label: "用户", value: "name"},
							{label: "聯絡電話", value: "phone"},
							{label: "快遞單號", value: "orders"},
							{label: "提貨櫃點", value: "orderhome"},
							{label: "重量(kg)", value: "weight"},
							{label: "合計費用", value: "amountall"},
							{label: "Pdd费用", value: "pddamount"},
							{label: "到付運費", value: "freight_collect"},
							{label: "加收附加費", value: "additional_fee"},
							{label: "超時費", value: "overtime_fee"},
							{label: "代收費", value: "amount"},
							{label: "門店立減費", value: "discount"},
							{label: "會員積分支付", value: "credit"},
							{label: "現金支付", value: "cash"},
							{label: "澳門通支付", value: "macaupay"},
							{label: "Mpay支付", value: "mpay"},
							{label: "支付寶支付", value: "alipay"},
							{label: "中銀POS支付", value: "boc"},
							{label: "工商POS支付", value: "icbc"},
							{label: "微信", value: "wechat"},
							{label: "Jpoint", value: "jpoint"},
							{label: "袋號", value: "sack_number"},
							{label: "是否線上", value: "online_order"},
							{label: "是否同城", value: "goods_type"},
							{label: "订单类型", value: "type"},
							{label: "包裹类型", value: "stype"},
							{label: "櫃店類型", value: "arrive_type"},
							{label: "所屬公司", value: "company"},
							{label: "簽收時間", value: "created_at"},
							{label: "備註", value: "remark"},
							{label: "備註2", value: "remarks"},
						],
						content: data3
					}, {
						sheet: '已簽收總覽(拼多多)',
						columns: [
							{label: "縂件數", value: "count"},
							{label: "合計費用", value: "sum"},
							{label: "Pdd合計費用", value: "pddsum"},
							{label: "已收總計", value: "insum"},
							{label: "到付費用", value: "freight_collect"},
							{label: "縂重量(kg)", value: "weight"},
						],
						content: [
							{
								count: this.filterCon(data3).count,
								sum: this.filterCon(data3).sum,
								pddsum: this.filterCon(data3).pddsum,
								insum: this.filterCon(data3).insum,
								freight_collect: this.filterCon(data3).freight_collect,
								weight: this.filterCon(data3).weight
							},
						]
					}]
					xlsx(table, {
						fileName: this.csvFilename,
						extraLength: 3,
						writeMode: "writeFile",
						writeOptions: {},
						RTL: false,
					})

					this.isSubmiting = false;
					this.isLoadExcel = false;
				} else {
					this.$Utils.showTipInfo(res)
					this.isSubmiting = false;
					this.isLoadExcel = false;
				}
			}).catch((e) => {
				console.log(e)
				this.$Utils.showTipInfo('暫無數據或導出失敗')
				this.isSubmiting = false;
				this.isLoadExcel = false;
			})
		},
		//pager
		handlePageSizeChange(value) {
			this.pageIndex = 1;
			isthis.sums = 0;
			this.getList();
		},
		handlePageInput() {
			let value = ('' + this.pageInput).replace(/\D/g, '');
			let pageCount = Math.ceil(this.totalCount / this.curPageSize);
			if (value > pageCount) {
				value = pageCount;
			}
			isthis.sums = 0;
			this.pageInput = value;
		},
		handlePageEnter() {
			if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
			if (this.pageInput == 0) {
				this.pageInput = 1;
			}
			this.pageInput = parseInt(this.pageInput);
			this.pageIndex = this.pageInput;
			isthis.sums = 0;
			this.getList();
		},
		handlePageChange(value) {
			this.pageIndex = value;
			isthis.sums = 0;
			this.getList();
		},
		// 多選 勾選 顯示總金額
		/*handleSelectionChange() {
		 let sums = 0;
		 this.curCheckedList = this.$refs.table.getSelection();
		 this.curCheckedList.forEach((item => {
		 sums += item.sum
		 }))
		 isthis.sums = Math.floor(sums);
		 },*/
		handleSelectionChange() {
			let sums = 0;
			this.curCheckedList = this.$refs.table.getSelection();
			this.curCheckedList.forEach((item => {
				if (item.pay_type == '未在APP內付款') {
					sums += item.sum
				} else {
					sums += item.outtimepay
				}
			}))

			isthis.sums = Math.floor(sums)
		},
	}
};
</script>

<style lang="scss" scoped>
@import "Signed.scss";
</style>
<style>
.ivu-table td.demo-table-info-column {
	background-color: #FFEBDE;
	color: #000;
}

.ivu-table td.demo-table-info-cell-name {
	background-color: #D6E7FF;
	color: #000;
}
</style>
